module.exports = __webpack_public_path__ + "img/pick-me.55f266ab.png";